import React from 'react';
import TopLanding from '../../shared/components/TopLanding';

function Gallery() {
    return (
        <div>
            <TopLanding />
        </div>
    )
}

export default Gallery;
